import React from 'react'

export default function LectureTipsCard() {
  const tips = [
    'Lectures are automatically validated to avoid conflicts in schedule for Students, Faculty and Classroom. Check on "Ignore duplication" to ignore the conflict for this lecture.',
    'Plan time is the scheduled time of the lecture and Actual time is the executed time of the lecture. Actual time is used for calculating payouts of visiting faculty. Actual time can be updated after the lecture is conducted, by editing the entry or by clicking on the biometric button. Lectures marked as "Extra Lecture" are excluded from payout calculation.',
    'Lecture can be conducted for Single or Multiple Branches / Batches / Schools by choosing "All" option.',
    'Choose School/College name for lectures which are targeted for students of a particular school/college, based on their Syllabus.',
    'After saving the lecture, click on Attendance button, to record attendance of students for the selected lecture',
    'You can send Lecture Schedule by SMS to students and Faculty by clicking on SMS button.',
    'Save & Continue option will save current lecture and allow you to add next lecture. To facilitate data entry, time will be advanced to next time slot and all fields except faculty & subject would be carried over to next screen.',
  ]

  return (
    <div className="rounded-3xl border border-primary/20 bg-gradient-to-b from-primary/[0.04] to-surface-container-lowest p-6 shadow-xs">
      <div className="flex items-center gap-3 border-b border-primary/10 pb-4">
        <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary/10 text-primary">
          <span className="material-symbols-outlined text-lg">lightbulb</span>
        </div>
        <div>
          <h4 className="font-display text-xs font-black uppercase tracking-wider text-primary">
            TIPS &amp; Guidelines
          </h4>
          <p className="text-[11px] text-on-surface-variant font-medium">Standard Lecture Operations</p>
        </div>
      </div>

      <ul className="mt-4 space-y-3 text-xs text-on-surface-variant leading-relaxed">
        {tips.map((tip, idx) => (
          <li key={idx} className="flex items-start gap-2.5">
            <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/10 text-[10px] font-bold text-primary select-none mt-0.5">
              *
            </span>
            <span className="font-medium text-on-surface/90">{tip}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
